import { Link, useSearchParams } from 'react-router-dom';

import { useEmbedBootstrap } from '../use-widget-bootstrap';
import { PATH } from '../widget-lib/path-routes';

const ctaClass =
  'inline-flex min-h-10 w-full items-center justify-center rounded-full bg-[var(--accent-bg)] px-5 text-[13px] font-semibold text-[var(--accent-fg)] shadow-sm transition hover:bg-[var(--accent-bg-hover)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)] sm:w-auto';

/**
 * В URL есть `org_slug`, но нет key/kid+exp+sig — конфиг виджета не загрузить; гостевой просмотр недоступен до корректной ссылки.
 */
export default function GlobalWidgetAwaitingSignedUrlPage() {
  const [searchParams] = useSearchParams();
  const qs = searchParams.toString();
  const suffix = qs ? `?${qs}` : '';
  const { bootstrapHint } = useEmbedBootstrap();

  return (
    <section className="w-full min-w-0 space-y-5 rounded-2xl border border-[var(--border)] bg-[var(--bg-elevated)] p-5 shadow-[var(--shadow-card)] sm:p-6">
      <div>
        <p className="text-[12px] font-semibold uppercase tracking-wide text-[var(--text-muted)]">Глобальный виджет</p>
        <h1 className="mt-1 text-xl font-bold tracking-tight text-[var(--text)] sm:text-2xl">Нужна подписанная ссылка</h1>
      </div>
      {bootstrapHint ? (
        <p className="text-sm leading-relaxed text-[var(--text-muted)]">{bootstrapHint}</p>
      ) : (
        <p className="text-sm leading-relaxed text-[var(--text-muted)]">
          Откройте виджет по ссылке из CRM студии: в адресе должны быть параметры подписи (например kid, exp, sig) или ключ{' '}
          <span className="font-mono text-[12px]">key</span> — их выдаёт администратор организации.
        </p>
      )}
      <p className="text-xs leading-relaxed text-[var(--text-muted)]">
        Если вы уже клиент студии, можно войти по телефону или паролю — контекст организации задаётся в ссылке со slug.
      </p>
      <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap">
        <Link to={`${PATH.signIn}${suffix}`} className={ctaClass}>
          Вход в приложение
        </Link>
      </div>
    </section>
  );
}
